import { render, staticRenderFns } from "./addCandidate.vue?vue&type=template&id=18e16dd4&"
import script from "./addCandidate.vue?vue&type=script&lang=js&"
export * from "./addCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports